/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:2ffd454d-ae32-4ef1-9a92-83a2b5067e10",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_rXaIS8RrD",
    "aws_user_pools_web_client_id": "33fed87b3tq03pkug0mm0l5iq7",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://wverjj7lnzgpjamffthyunia7q.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
